const batchData = function() {
	return {
		batchData: []
	}
}

const batchMethods = function(ref = 'list') {
	return {
		batchSelect() {
			this.batchData = this.$refs[ref].getData('selected');
		},

		batchCancel() {
			this.$refs[ref].getRow('selected').forEach(row => {
				row.select(false);
			});
		}
	}
}

export {
	batchData,
	batchMethods
}